import React, { FC, useState } from "react";
import {
  styled,
  InputBase,
  InputLabel,
  Box,
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
} from "@mui/material";
export const TankyouContact = () => {
  return (
    <>
      <DialogTitle textAlign="center" fontWeight={900} fontSize={90}>
        Thank you for your inquiry!
      </DialogTitle>
      <Divider />
      <DialogContent
        sx={{
          padding: 1,
          textAlign: "center",
          WebkitBoxAlign: "center",
          WebkitBoxPack: "center",
          justifyContent: "center",
        }}
      >
        <Stack spacing={1} padding={0}>
          <Grid container spacing={0.1}>
            <Grid item md={12} xs={12}>
              <Box>
                <h1>お問い合わせありがとうございます。</h1>
                <h2>弊社より改めてご連絡致します。</h2>
                <h2>今しばらくお待ち下さい。</h2>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </DialogContent>
    </>
  );
};
